import styled, { css } from 'styled-components'

export const Container = styled.div`
  width: 100%;
`

const visibleCss = ({ visible }) =>
  visible &&
  css`
    display: block;
  `

const shouldForwardProp = prop => {
  return !['visible'].includes(String(prop))
}

export const Slide = styled.img.withConfig({
  shouldForwardProp,
})`
  display: none;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 100%;
  width: 100%;
  object-fit: contain;

  ${visibleCss}
`
